import * as UIActions from "../../../shared/redux/UIActions";
import BenchmarkManager from "../../benchmark/benchmarkManager";
import { notificacaoActions } from "../../notificacao/redux";
import usuarioService from "../../usuario/usuarioService";
import AuthManager from "../auth0Manager";
import * as usuarioAuth0VinculoActions from "./usuarioAuth0VinculoActions";

export const MSG = {
  OBTEM_USUARIO_AUTH_FALHA: "Não foi possível obter dados usuario auth0.",
  ATUALIZA_USUARIO_AUTH_SUCESSO: "Permissões do usuário atualizadas.",
  ATUALIZA_USUARIO_AUTH_FALHA: "Não foi possível atualizar permissões usuário.",
  GERENCIA_BENCHMARK_FALHA: "Permissões salvas, mas não foi possível atualizar o acesso ao Benchmark.",
};

const obtemUsuarioAuth0 = (emailUsuario, idUsuario) => async (dispatch) => {
  try {
    const usuarioAuth0 = await AuthManager.obtemUsuarioAuthPeloEmail(
      emailUsuario,
      idUsuario,
    );
    dispatch(usuarioAuth0VinculoActions.setUsuarioAuth0(usuarioAuth0));
  } catch (error) {
    dispatch(notificacaoActions.notificaErro(MSG.OBTEM_USUARIO_AUTH_FALHA));
  }
};

const atualizaPermissoesUsuarioAuth0 =
  (permissoes, nomeUsuario) => async (dispatch, getState) => {
    try {
      dispatch(UIActions.setLoading());
      let arrayPermissoes = Object.keys(permissoes)
        .filter((key) => permissoes[key])
        .filter(
          (key) =>
            key !== "usuario_Master_Tableau" &&
            key !== "usuario_Master" &&
            key !== "usuarioTableau" &&
            key !== "acessa_benchmark",
        );

      if (permissoes.usuarioTableau) {
        arrayPermissoes = [
          "usuario_analytics",
          "usuario_tableau",
          "acessa_plataforma",
        ];
      } else if (permissoes.usuario_Master_Tableau) {
        arrayPermissoes.push("usuario_tableau");
      }

      const usuario = getState().usuarioAuth.usuarioAuth0;

      await usuarioService.atualizaPermissoesUsuario(
        usuario.login,
        arrayPermissoes,
      );

      const benchmarkMudou =
        permissoes.acessa_benchmark !== usuario.permissoes.acessa_benchmark;
      if (benchmarkMudou) {
        const associacoes = getState().benchmark.associacoes;
        const associacoesGrant = associacoes.map((a) => ({
          customer_name: a.nomeCliente,
          farm_names: a.fazendas
            .filter((f) => f.has_access)
            .map((f) => f.name),
        }));
        try {
          await BenchmarkManager.gerenciarAcesso(
            usuario.email,
            permissoes.acessa_benchmark,
            nomeUsuario,
            associacoesGrant,
          );
          dispatch(
            usuarioAuth0VinculoActions.setUsuarioAuth0({
              ...usuario,
              permissoes: { ...usuario.permissoes, acessa_benchmark: permissoes.acessa_benchmark },
              benchmarkLocalUserStatus: permissoes.acessa_benchmark ? "active" : "inactive",
            }),
          );
        } catch (benchmarkError) {
          const responseData = benchmarkError && benchmarkError.response && benchmarkError.response.data;
          const apiMessage = typeof responseData === 'string'
            ? responseData
            : responseData && (responseData.message || responseData.error);
          const errorMessage = apiMessage
            ? MSG.GERENCIA_BENCHMARK_FALHA + " " + apiMessage
            : MSG.GERENCIA_BENCHMARK_FALHA;
          dispatch(notificacaoActions.notificaErro(errorMessage));
          dispatch(usuarioAuth0VinculoActions.setUsuarioAuth0({ ...usuario }));
          return;
        }
      }

      dispatch(
        notificacaoActions.notificaSucesso(MSG.ATUALIZA_USUARIO_AUTH_SUCESSO),
      );
    } catch (error) {
      console.log(error);
      dispatch(
        notificacaoActions.notificaErro(MSG.ATUALIZA_USUARIO_AUTH_FALHA),
      );
    } finally {
      dispatch(UIActions.setLoading());
    }
  };

export { atualizaPermissoesUsuarioAuth0, obtemUsuarioAuth0 };
